/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import { apiDataToDropdownList } from "../../../utils/sysHelpers";
import GridTable from "@nadavshaar/react-grid-table";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { toastError } from "../../../utils/sysToast";

class MobileUser extends Component {
  state = {
    data: {},

    contentHeader: "مستخدمين التطبيق",
    addButtonLabel: "اضافة فاتورة",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetMobileUsers",
    blockurl: "/api/data/BlockMobileUser",
    unblockUrl: "/api/data/UnblockMobileUser",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "اضافة فاتورة وكيل",
    modalSubmitButtonLabelAdd: "اضافة",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "تعديل فاتورة وكيل",
    modalSubmitButtonLabelEdit: "تعديل",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,

    tableData: [],
    tableColumns: [
      {
        id: 1,
        label: "الاوامر",
        field: "SYS_ACTIONS",
        width: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB1E"]) && data.IS_ACTIVE === "Y" && (
                <div className="inner" title="ايقاف">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleBlock(data)}
                  >
                    <i className="fa fa-ban" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB1F"]) && data.IS_ACTIVE === "N" && (
                <div className="inner" title="تفعيل">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleUnblock(data)}
                  >
                    <i className="fa fa-check" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
      {
        id: 2,
        label: "ID",
        field: "ID",
        width: "100px",
      },
      {
        id: 3,
        label: "الاسم",
        field: "FULL_NAME",
      },
      {
        id: 4,
        label: "رقم الهاتف",
        field: "PHONE_NUMBER",
      },
      {
        id: 5,
        label: "نوع المستخدم",
        field: "USER_ENTITY_TPYE",
      },
      {
        id: 6,
        label: "فعال",
        field: "IS_ACTIVE",
        width: "120px",
        cellRenderer: ({ data }) => {
          return (
            <span>
              <b>&nbsp;{data.IS_ACTIVE === "Y" ? "نعم" : "لا"}&nbsp;</b>
            </span>
          );
        },
      },
      {
        id: 7,
        label: "تاريخ الايقاف",
        field: "DEACTIVATE_DATE",
      },
      {
        id: 8,
        label: "محظور",
        field: "IS_BLOCKED",
        width: "120px",
        cellRenderer: ({ data }) => {
          return (
            <span>
              <b>&nbsp;{data.IS_BLOCKED === "Y" ? "نعم" : "لا"}&nbsp;</b>
            </span>
          );
        },
      },
      {
        id: 9,
        label: "تاريخ الحظر",
        field: "BLOCK_DATE",
      },
      {
        id: 10,
        label: "تاريخ اخر تسجيل دخول",
        field: "LAST_LOGIN_DATE",
      },
      {
        id: 11,
        label: "تاريخ الادخال",
        field: "INSERT_DATE",
      },
    ],
  };

  handleBlock(row) {
    confirmAlert({
      title: "ايقاف مستخدم",
      message: "هل أنت متأكد من ايقاف هذا المستخدم",
      buttons: [
        {
          label: "نعم",
          onClick: () => {
            post(
              this.state.blockurl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "الغاء",
          onClick: () => null,
        },
      ],
    });
  }

  handleUnblock(row) {
    confirmAlert({
      title: "تفعيل مستخدم",
      message: "هل أنت متأكد من تفعيل هذا المستخدم",
      buttons: [
        {
          label: "نعم",
          onClick: () => {
            post(
              this.state.unblockUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        {
          label: "الغاء",
          onClick: () => null,
        },
      ],
    });
  }

  componentDidMount() {
    this.getData();
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = null);
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      submitData,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  render() {
    return (
      <div className="sys-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{this.state.contentHeader}</h4>
          </div>
          <div className="col-10 flex-container-left"></div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          headerStyle={{ "background-color": "#F0F0F0", color: "black" }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode
                ? this.state.modalHeaderEdit
                : this.state.modalHeaderAdd}
            </h5>
          }
          footer={
            <div>
              <Button
                label={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonLabelEdit
                    : this.state.modalSubmitButtonLabelAdd
                }
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label="الغاء"
                icon="fa fa-close"
                className="p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "agentId",
                label: "الوكيل",
                options: this.state.allAgents,
                disabled: false,
              },
              {
                type: "text",
                id: "amount",
                label: "المبلغ",
                disabled: false,
              },
              {
                type: "text",
                id: "diamonds",
                label: "عدد الماسات",
                disabled: false,
              },
              {
                type: "defaultdate",
                id: "billDate",
                label: "تاريخ الفاتورة",
                disabled: false,
              },
              {
                type: "text",
                id: "billNumber",
                label: "رقم الفاتورة",
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <GridTable
          columns={this.state.tableColumns}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 30, 40]}
          showColumnVisibilityManager={false}
          texts={{
            search: "بحث:",
            totalRows: "إجمالي عدد البيانات:",
            rows: "الصف:",
            selected: "المحدد",
            rowsPerPage: "عدد الصفوف في الصفحة:",
            page: "الصفحة:",
            of: "من",
            prev: "السابق",
            next: "التالي",
            columnVisibility: "اظهار الاعمدة",
          }}
        />
      </div>
    );
  }
}

export default MobileUser;
